import { Button } from 'antd';
import React from 'react';

interface SimpleSingleSelectButtonGroupProps {
  label: string;
  options: string[];
  selectedValue: string;
  setSelectedValue: (value: string) => void;
  otherOptionLabel?: string; // like "Other"
  otherInputValue?: string;
  error?: string;
  showRadioButton?: boolean;
  setOtherInputValue?: (value: string) => void;
}

const SimpleSingleSelectButtonGroup: React.FC<SimpleSingleSelectButtonGroupProps> = ({
  label,
  options,
  selectedValue,
  setSelectedValue,
  otherOptionLabel,
  otherInputValue,
  setOtherInputValue,error='',
  showRadioButton = false,
}) => {
  return (
    <div className="col-span-1">
      <label className="block common-bold-label pb-[14px]">{label} {error!==''&&!selectedValue && 
          <div className="text-red-500 text-sm !my-0">{error}</div>}</label>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isSelected = selectedValue === option;
          const isOther = otherOptionLabel && option === otherOptionLabel;

          return (
            <Button
              key={option}
              type="text"
              onClick={() => setSelectedValue(option)}
              style={{
                backgroundColor: isSelected ? '#d1e9ff' : 'transparent',
                border: `1px solid ${isSelected ? '#53b1fd' : '#e4e7ec'}`,
                color: isSelected ? '#1849a9' : '#1d2939',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = isSelected ? '#d1e9ff' : '#F9FAFB')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = isSelected ? '#d1e9ff' : 'white')
              }
              className={`flex items-center gap-x-[10px] px-[20px] py-[4px] rounded-[30px] font-medium text-sm`}
            >
              {showRadioButton && !isOther && (
                <div
                  className={`w-4 h-4 flex items-center justify-center rounded-[30px] border ${
                    isSelected ? 'border-[#0152fb] bg-[#d1e9ff]' : 'border-[#e4e7ec]'
                  }`}
                >
                  {isSelected && <div className="w-2 h-2 bg-[#0152fb] rounded-[30px]" />}
                </div>
              )}
              {isOther && isSelected ? (
                <input
                  type="text"
                  placeholder="Your Answer"
                  className="outline-none border-none bg-transparent text-[#1d2939] text-sm"
                  value={otherInputValue}
                  onChange={(e) => setOtherInputValue?.(e.target.value)}
                />
              ) : (
                option
              )}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default SimpleSingleSelectButtonGroup;
